import { ref, string } from 'yup';

/**
 * Adicionar ponto final no fim das mensagens.
 */
export const confirmPasswordSchema = (passwordFielName: string = 'password') =>
  string()
    .typeError('A confirmação de senha precisa ser um campo de texto')
    .required('Informe a confirmação de senha')
    .oneOf([ref(passwordFielName)], 'As senhas devem ser iguais');
